
<template>
  <div class="welcoming">
    <div class="welcoming__container">
      <count-indicator :content="content" />
    </div>
  </div>
</template>

<script>
import FastSearch from './FastSearch'
import CountIndicator from './CountIndicator'

export default {
  components: {
    'fast-search': FastSearch,
    'count-indicator': CountIndicator
  },
  props: {
    content: {
      type: Object
    }
  }
}
</script>
<style lang="scss">
.welcoming {
  display: flex;
  justify-items: center;
  flex-direction: column;

  &__container {
    cursor: pointer;
    padding: 11px 4px;
    width: 100%;
    border-radius: 3px;

    .count-indicator {
      margin: 0;
    }
  }
}
</style>
